<template>
  <div class="search">
    <div class="title-left">
      <div class="title-left-img">
        <img :src="brandInfo.image" />
      </div>
      <div class="title-left-list">
        <p>{{ brandInfo.name }}</p>
        <ul>
          <!-- -->
          <li
            :class="{ active: isActive == 'goodslist' }"
            @click="getActive('goodslist')"
          >
            产品列表
          </li>
          <li
            :class="{ active: isActive == 'advantage' }"
            @click="getActive('advantage')"
          >
            优势
          </li>
          <li
            :class="{ active: isActive == 'industry' }"
            @click="getActive('industry')"
          >
            应用行业
          </li>
          <li
            :class="{ active: isActive == 'aboutus' }"
            @click="getActive('aboutus')"
          >
            关于{{ brandInfo.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="title-right">
      <ul class="title-right-class">
        <li
          v-for="(classinfo, index) in brandClassList"
          :key="index"
          :class="{ titlerightclassli: classinfo.isChecked == true }"
          @click="checkClass(index)"
        >
          {{ classinfo.name }}
        </li>
      </ul>
      <div class="title-right-attr-box">
        <ul
          class="title-right-attr"
          v-for="(classinfo, index) in brandClassList"
          :key="index"
          v-if="classinfo.isChecked"
        >
          <li
            class="title-right-attr-li"
            v-for="(sclass, sindex) in classinfo.list"
            :key="sindex"
          >
            <div class="title-right-attr-li-title">{{ sclass.name }}：</div>
            <div class="title-right-attr-li-item">
              <p class="title-right-attr-li-item-p">
                <span
                  class="title-right-attr-li-item-line"
                  v-for="(tclass, tindex) in sclass.list"
                  :key="tindex"
                  @click="checkitemClass(index, sindex, tindex)"
                  ><img v-if="tclass.isChecked" :src="choose" /><img
                    v-else
                    :src="nochoose"
                  /><span>{{ tclass.name }}</span></span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="title-right-attr-span" @click="reset()">重置</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: {
        brandimg: "/static/brand/01.png",
        brandname: "阿童木机器人",
      },
      isActive: "goodslist",
      choose: "/static/brand/choose.png",
      nochoose: "/static/brand/nochoose.png",
    };
  },
  props: ["brandClassList", "brandInfo"],
  methods: {
    checkClass(index) {
      this.$emit("checkClass", index);
    },
    checkitemClass(index, sindex, tindex) {
      this.$emit("checkitemClass", index, sindex, tindex);
    },
    reset() {
      this.$emit("reset");
    },
    getActive(val) {
      this.isActive = val;
      var offsetTop = document.querySelector("#" + val).offsetTop - 50;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.search {
  margin-top: 20px;
  overflow: hidden;
  padding-bottom: 60px;
}
.search .title-left {
  margin-top: 27px;
  width: 268px;
  padding: 0 5px;
  float: left;
}
.search .title-left .title-left-img {
  width: 100%;
  height: 125px;
  margin-bottom: 20px;
  background-color: #fff;
  text-align: center;
  box-shadow: 0px 0px 8px rgb(72 72 72 / 20%);
}
.search .title-left .title-left-img img {
  height: 100%;
}
.search .title-left .title-left-list {
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
  width: 100%;
}
.search .title-left .title-left-list p {
  font-size: 22px;
  color: #666666;
  height: 59px;
  line-height: 59px;
  padding-left: 15px;
}
.search .title-left .title-left-list ul li {
  height: 37px;
  line-height: 37px;
  padding-left: 15px;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
}
.search .title-left .title-left-list ul .active {
  background-color: #fbb113;
  color: #fff;
}
.search .title-right {
  width: 909px;
  float: right;
}
.search .title-right .title-right-class {
  overflow: hidden;
  padding-bottom: 5px;
}
.search .title-right .title-right-class li {
  width: 112px;
  text-align: center;
  float: left;
  font-size: 16px;
  color: #666666;
  position: relative;
  padding: 6px 0;
  cursor: pointer;
}
.search .title-right .title-right-class li::after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 5px;
  content: "";
  background-color: #dbdbdb;
}

.search .title-right .title-right-class .title-right-class-li::after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 5px;
  content: "";
  background-color: #fbb113;
}
/**筛选项 */
.search .title-right .title-right-attr {
  margin-bottom: 20px;
}
.search .title-right .title-right-attr .title-right-attr-li {
  overflow: hidden;
  padding-left: 14px;
  padding-top: 20px;
}

.search .title-right .title-right-attr-box {
  background-color: #fff;
  overflow: hidden;
}

.search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-title {
  width: 114px;
  float: left;
  line-height: 2;
  font-size: 14px;
  color: #666666;
}
.search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item {
  width: 779px;
  float: right;
}
.search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  .title-right-attr-li-item-p {
  display: flex;
  flex-wrap: wrap;
  line-height: 2;
}
.search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  .title-right-attr-li-item-line {
  margin-right: 20px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}
.search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  span {
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
  margin-left: 10px;
}
.title-right-attr-span {
  float: right;
  background: #fbb113;
  border-radius: 17px;
  color: #fff;
  width: 75px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  margin-top: 20px;
  cursor: pointer;
}
.search .title-right .title-right-class .titlerightclassli::after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 5px;
  content: "";
  background-color: #fbb113;
}
</style>


// WEBPACK FOOTER //
// src/components/brand/brandsearch.vue